module.exports = __webpack_public_path__ + "img/service2.ef8dbb39.jpg";